export { default as ListModelDetails } from './List'
export { default as CreateModelDetail } from './Create'
export { default as ShowModelDetail } from './Show'
export { default as EditModelDetail } from './Edit'
